





















































import { createComponent, inject } from "@vue/composition-api";
import ProductListUnitForm from "./ProductListUnitForm.vue";
import ListUnitTable from "@/components/ListUnitTable.vue";
import { ProductListUnit } from "@megarax/client/src/resources/plm";
import {
  sheetOptionsSymbol,
  SheetHighlights,
} from "@/components/sheet/SheetEntries";

interface Props {
  value: ProductListUnit[];
}

export default createComponent<Props>({
  components: { ListUnitTable },
  props: {
    value: { required: true },
  },
  setup(props, ctx) {
    const sheetHighlights = inject(sheetOptionsSymbol, {} as SheetHighlights);

    const getRowClass = ({ row: unit }: { row: ProductListUnit }) => {
      const unitHighlights = sheetHighlights["units"];
      if (unitHighlights)
        if (unitHighlights === true || unitHighlights[unit.product!.id!])
          return "table-warning";
    };

    return {
      getRowClass,
    };
  },
});
